<template>
    <div id="pvzMapContainer">
        <!-- <yandex-map
                @map-was-initialized="setMap"
                :coords="center"
                :zoom="zoom"
                :controls="[]"
                :cluster-options="clusterOptions"
                :use-object-manager="true"
            >
                <ymap-marker cluster-name="1" v-for="(marker, index) in markers" :coords="marker.coord" :icon="marker.icon" :marker-id="index" :key="index" />
            </yandex-map> -->
        <div id="pvzMap"></div>
        <div class="zoom">
            <div class="zoom__in" @click="map.setZoom(map.getZoom() + 1)">
                <svg-icon name="plus--large" width="15" height="15" />
            </div>
            <div class="zoom__out" @click="map.setZoom(map.getZoom() - 1)">
                <svg-icon name="minus--large" width="15" height="15" />
            </div>
        </div>
    </div>
</template>
<script>
import { loadYmap } from "vue-yandex-maps";
export default {
    name: "PvzMap",
    props: {
        isStatic: {
            type: Boolean,
            default() {
                return false;
            },
        },
        vendorCode: {
            type: String,
            default() {
                return "";
            },
        },
        pvz: {
            type: Array,
            default() {
                return [];
            },
        },
        activeMarkerIndex: {
            type: [Number, Boolean],
            default() {
                return false;
            },
        },
    },
    data() {
        return {
            center: null,
            zoom: null,
            ymaps: null,
            timeout: null,
            markers: [],
            map: null,
            objectManager: null,
        };
    },
    computed: {
        centerAndZoom() {
            let mapElement = document.getElementById("pvzMap");
            let markerCoords = this.markers.map((el) => el.geometry.coordinates);
            let centerAndZoom = this.ymaps.util.bounds.getCenterAndZoom(
                this.ymaps.util.bounds.fromPoints(markerCoords),
                [mapElement.offsetWidth, mapElement.offsetHeight]
            );
            return centerAndZoom;
        },
    },
    watch: {
        activeMarkerIndex(val) {
            if (val !== false) {
                this.$nextTick(() => {
                    // this.zoom = 17;
                    // this.center = this.markers[val].coord;
                    this.map.setCenter(this.markers[val].geometry.coordinates, 17);
                });
            } else {
                // this.zoom = this.markers.length == 1 ? 12 : this.centerAndZoom.zoom;
                // this.center = this.markers.length == 1 ? this.markers[0].coord : this.centerAndZoom.center;
                this.map.setCenter(
                    this.markers.length == 1 ? this.markers[0].geometry.coordinates : this.centerAndZoom.center,
                    this.markers.length <= 1 ? 12 : this.centerAndZoom.zoom
                );
            }
        },
        pvz() {
            this.createMarkers();
            this.map.geoObjects.add(this.objectManager);
            this.map.setCenter(this.center, this.zoom);
        },
    },
    methods: {
        initMap() {
            if (!this.map) {
                this.map = new ymaps.Map("pvzMap", {
                    center: this.center,
                    zoom: this.zoom,
                    controls: [],
                });
            }

            this.map.geoObjects.add(this.objectManager);
            if (this.activeMarkerIndex !== false) {
                this.map.setCenter(this.markers[this.activeMarkerIndex].geometry.coordinates, 17);
            }
            this.$emit("mapReady");
        },
        createMarkers() {
            this.objectManager.removeAll();
            this.markers = [];
            this.pvz.forEach((element, index) => {
                this.markers.push({
                    type: "Feature",
                    id: index,
                    geometry: {
                        type: "Point",
                        coordinates: [element.latitude, element.longitude],
                        // icon: this.icon,
                    },
                });
            });
            this.objectManager.add(this.markers);
            this.objectManager.objects.events.add("click", (e) => {
                this.$emit("openPVZ", e.get("objectId"));
            });
            this.zoom = this.markers.length == 0 ? 3 : this.markers.length == 1 ? 12 : this.centerAndZoom.zoom;
            this.center = this.markers.length == 1 ? this.markers[0].geometry.coordinates : this.centerAndZoom.center;
        },
    },
    async mounted() {
        await loadYmap({
            apiKey: "0fe09a79-7c31-4723-9b82-6af67e4c9487",
            lang: "ru_RU",
            coordorder: "latlong",
            version: "2.1",
        });
        this.ymaps = ymaps;
        this.objectManager = new ymaps.ObjectManager({
            clusterize: true,
            clusterHasBalloon: false,
            geoObjectOpenBalloonOnClick: false,
            clusterDisableClickZoom: false,
            clusterOpenBalloonOnClick: false,
            clusterIconContentLayout: ymaps.templateLayoutFactory.createClass(
                '<div class="clusterIcon text_11" style="color: #fff;text-align:center;line-height:20px;padding-left:2px">{{ properties.geoObjects.length }}</div>'
            ),
            // Зададим массив, описывающий иконки кластеров разного размера.
            clusterIcons: [
                {
                    href: "https://post-post-scriptum.com/img/rect.svg",
                    size: [20, 20],
                    offset: [-10, -10],
                },
            ],
            // iconHover: {
            //     layout: "default#image",
            //     imageHref: "https://post-post-scriptum.com/img/crystal.svg",
            //     imageSize: [24, 24],
            //     imageOffset: [-12, -12],
            // },
            geoObjectIconLayout: "default#image",
            geoObjectIconImageHref: "https://post-post-scriptum.com/img/crystal.svg",
            geoObjectIconImageSize: [16, 16],
            geoObjectIconImageOffset: [-8, -8],
        });
        this.objectManager.clusters.events.add("mouseenter", (e) => {
            const id = e.get("objectId");
            this.objectManager.clusters.setClusterOptions(id, {
                iconContentLayout: ymaps.templateLayoutFactory.createClass(
                    '<div class="clusterIcon clusterIcon--hover text_11" style="color: #fff;text-align:center;line-height:20px;padding-left:2px">{{ properties.geoObjects.length }}</div>'
                ),
            });
        });
        this.objectManager.clusters.events.add("mouseleave", (e) => {
            const id = e.get("objectId");
            this.objectManager.clusters.setClusterOptions(id, {
                iconContentLayout: ymaps.templateLayoutFactory.createClass(
                    '<div class="clusterIcon text_11" style="color: #fff;text-align:center;line-height:20px;padding-left:2px">{{ properties.geoObjects.length }}</div>'
                ),
            });
        });
        this.createMarkers();
        this.initMap();
    },
};
</script>
<style lang="less">
.clusterIcon {
    animation: bp 0.3s ease forwards reverse;
    &--hover {
        animation: bp 0.3s ease forwards;
        background: @accent;
    }
}
@keyframes bp {
    from {
        background: #000;
    }
    to {
        background: @accent;
    }
}
</style>
<style lang="less" scoped>
.zoom {
    position: absolute;
    z-index: 7;
    right: 16px;
    top: 50%;
    margin-top: -39px;
    div {
        width: 39px;
        height: 39px;
        border: 1px #000 solid;
        display: flex;
        align-items: center;
        justify-content: center;
        .trs(all);
        background: #fff;
        cursor: pointer;
        svg {
            display: block;
        }
        + div {
            margin-top: -1px;
        }
        &:hover {
            background: @accent;
            border-color: @accent;
            color: #fff;
        }
    }
}
.ymap-container {
    height: 100%;
    width: 100%;
    border-left: 1px solid @border2;
    margin-left: -1px;
    .is_static & {
        position: absolute;
        top: 0;
        left: 0;
    }
}
.store {
    margin: 0 -32px;
    padding: 25px 32px;
    border-bottom: 1px solid @border2;
    cursor: pointer;
    .trs(background);
    @media @sm {
        margin: 0 -16px;
    }
    &:hover {
        background: #fff;
    }
    &__title {
        margin-bottom: 12px;
    }
    &__info {
        margin-top: 4px;
    }
    &__address {
        margin-top: 4px;
    }
}
.row {
    @media @sm {
        flex-direction: column;
        .col--no-padding:not(:first-child) {
            flex-grow: 1;
            position: relative;
        }
    }
}
.is_details {
    height: 100%;
}
#pvzMap {
    height: calc(100dvh - 108px);
    min-height: 100%;
    .is_details & {
        height: 100%;
        flex-grow: 1;
        min-height: auto;
        position: relative;
        .ymap-container {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
        }
    }
    @media @sm {
        position: absolute;
        height: auto;
        min-height: 100vw;
        border-left: 0;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        border-bottom: 1px solid @border2;
        .is_static & {
            position: relative;
            border-bottom: 0;
        }
    }
}
.modal-detail {
    &__header {
        padding: 32px;
        padding-bottom: 140px;
        border-bottom: 1px solid @border2;
        .modal-detail__row + .modal-detail__row {
            margin-top: 8px;
        }
        @media @sm {
            padding: 32px 16px;
        }
    }
    &__row {
        display: flex;
        justify-content: space-between;
        div {
            width: 50%;
        }
        div + div {
            text-align: right;
            padding-left: 20px;
        }
        &--lined {
            padding: 12px 0;
            & + & {
                border-top: 1px solid @border2;
            }
        }
    }
    &__content {
        padding: 20px 32px 32px;
        @media @sm {
            padding: 20px 16px 32px;
        }
        a {
            color: #000;
        }
    }
}
</style>
